import * as base from "./base";

/**
 * PCB layout rule set selectors namespace
 *
 * Usage:
 * - pcbLayoutRules.byUid('uid')(state) - Get rule set by UID
 * - pcbLayoutRules.globalRules(state) - Get global rules
 * - pcbLayoutRules.disabledByUid('uid')(state) - Check if rule is disabled
 * - pcbLayoutRules.nodeSpecificRules('uid')(state) - Get node-specific rules
 */
export const pcbLayoutRules = {
    ...base,
} as const;

export type PcbLayoutRulesSelectors = typeof pcbLayoutRules;
